export enum ScenarioType {
    Enterprise = 0,
    Consumer,
    ShadowMailbox
}
